export const name = 'assetLibUploadDialogController';
export default function assetLibUploadDialogController($mdDialog, $state, $log, impositionTemplatesService, L10NFilter, errorDialogOpen, unitsConverterFactory, $scope) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    // data to pass to dialog:
    // =====================================
    // title - e.g. 'imposer.composer-main.Template_Imposition_Upload_Dialog_Title' (required)
    // fileType - e.g. '.impp' (required)
    // fileTypeDisplay - e.g. 'IMPP' (required)
    // uploadMethod - function (required)
    // mimeType - optional (octet-stream as default)
    // analyticsUploadSuccess - function Optional
    // analyticsUploadFail - function Optional
    // deleteEntity - function Optional - callback for entity deletion in case of cancellation after entity exist already


    let vm = this;

    vm.cancel = cancel;
    vm.select = select;
    vm.selectedFileToUpload = null;
    vm.selectedLibraries = [];
    vm.fileSelected = fileSelected;
    vm.onFileSelect = onFileSelect;
    vm.toggleAssetLibrarySelection = toggleAssetLibrarySelection;
    vm.showDropArea = true;
    vm.showProgressBar = false;
    vm.isConstantChange = isConstantChange;
    vm.numOfElementsCallback = numOfElementsCallback;
    vm.isUploading = false;
    vm.uploadProgress = 0;
    vm.uploadProgressCallback = uploadProgressCallback;
    vm.goToAssetsLibraries = goToAssetsLibraries;
    vm.knownProgress = false;
    vm.isFileSelectedFlag = false;
    vm.uploadController = {cancel:false};
    vm.resetUploadDirective = false;
    vm.resetSelectionToggle = false;
    vm.filesAmountLimit = 15;
    vm.isFileSizeLimitNeeded = false;
    vm.isAdditionalInfoRequired = localStorage.getItem("isAdditionalInfoRequired") === null ? true : false;

    if(vm.isTemporaryAllowed !== undefined && vm.isTemporaryAllowed === false){
      vm.isConstant = true;
    }else{
      vm.isTemporaryAllowed = true;
      vm.isConstant = false;
    }

    vm.dismissAdditionalInfo = function(){
      $('.dialog-additional-info').slideUp();
      localStorage.setItem("isAdditionalInfoRequired", "false");
    };

    function fileSelected(selectedFileToUpload){
        vm.selectedFileToUpload = selectedFileToUpload;
        if(vm.isConstant && vm.fileSizeLimit && selectedFileToUpload.size >= vm.fileSizeLimit){
          vm.exceededFileSizeLimit = true;
          vm.formmatedFileSizeLimit = unitsConverterFactory.formatBytes(vm.fileSizeLimit);
        }else{
          vm.exceededFileSizeLimit = false;
        }
    }

    function isConstantChange(){
      if(vm.isConstant){
        vm.isFileSizeLimitNeeded = true;
      }else{
        vm.isFileSizeLimitNeeded = false;
      }
      if(vm.fileSizeLimit && vm.selectedFileToUpload !== null && vm.selectedFileToUpload.size >= vm.fileSizeLimit && vm.isConstant){
        vm.exceededFileSizeLimit = true;
        vm.formmatedFileSizeLimit = unitsConverterFactory.formatBytes(vm.fileSizeLimit);
      }else{
        vm.exceededFileSizeLimit = false;
      }
    }

    function numOfElementsCallback(numOfElements){
      vm.numOfElements = numOfElements;
    }

    function cancel(data) {
        let functionName='assetLibUploadDialogController.cancel';
        $log.info(angular.toJson({action:'function called', functionName:functionName}));

        vm.uploadController.cancel = true;

        if(vm.entityId && vm.deleteEntity){
            vm.deleteEntity(vm.entityId);
        }

        $mdDialog.cancel();
    }

    function onFileSelect($files){
        vm.isFileSelectedFlag = true;
        fileSelected($files[0]);
        vm.resetSelectionToggle = !vm.resetSelectionToggle;
    }

    function select() {
        let functionName='assetLibUploadDialogController.select';

        if(vm.selectedFileToUpload !== null){
          $log.info(angular.toJson({action:'function called', functionName:functionName, fileName:vm.selectedFileToUpload.name}));

          vm.isUploading = true;

          vm.showDropArea = false;
          vm.showProgressBar = true;

          if(vm.uploadMethod){
            vm.isUploading = true;
            vm.uploadMethod(vm.selectedFileToUpload, vm.uploadProgressCallback, vm.uploadController, null, vm.isConstant).then(function (assetLib) {
              $log.info(angular.toJson({action:'file uploaded successfully', functionName:functionName}));

              vm.selectedLibraries = [assetLib];
              if(vm.assetLibSelectedCallback){
                vm.assetLibSelectedCallback(vm.selectedLibraries);
              }

              if(vm.analyticsUploadSuccess){
                vm.analyticsUploadSuccess();
              }
              $mdDialog.hide();
            }, function(status) {
              $log.info(angular.toJson({action:'error uploading file', functionName:functionName}));

              if(vm.analyticsUploadFail){
                vm.analyticsUploadFail();
              }

              $mdDialog.hide();

              errorDialogOpen.openErrorDialog(status);

            });
          }else{
            $log.error(angular.toJson({action:'no upload method supplied', functionName:functionName}));
          }

          $log.info(angular.toJson({action:'function return', functionName:functionName}));
        }else if(vm.assetLibSelectedCallback && vm.selectedLibraries.length > 0){
          vm.assetLibSelectedCallback(vm.selectedLibraries);
          $mdDialog.hide();
        }
    }

    function uploadProgressCallback(uploadReportPercentage, entityId = null){
        if(entityId){
            vm.entityId = entityId;
        }

        if(uploadReportPercentage){
            vm.uploadProgress = uploadReportPercentage;
            vm.knownProgress = true;
            if(uploadReportPercentage === 100){
                vm.knownProgress = false;
            }
            $scope.$apply();
        }
    }

    function toggleAssetLibrarySelection(assetLib) {
      vm.isFileSelectedFlag = true;
      vm.resetUploadDirective = false;
      vm.resetUploadDirective = true;
      vm.selectedFileToUpload = null;
      vm.selectedLibraries = [assetLib];
      /*if(vm.selectedLibraries.includes(assetLib)){
        vm.selectedLibraries = vm.selectedLibraries.filter(curr => curr !== assetLib);
      }else{
        vm.selectedLibraries.push(assetLib);
      }*/
    }


    function goToAssetsLibraries(){
      $mdDialog.hide();
      $state.transitionTo('assets-management');
    }
    /*$scope.$on('$destroy', function() {
      vm.listMonitoringUtility.close();
    });*/
}
